import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../shared/components/Button';

const MemberLanding: React.FC = () => {
  return (
    <div className="min-h-screen bg-black text-white relative overflow-hidden">
      {/* Background effects */}
      <div className="absolute inset-0 bg-gradient-to-b from-blue-900/10 to-purple-900/10" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(67,56,202,0.05),transparent_50%)]" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom_left,rgba(126,34,206,0.05),transparent_50%)]" />
      
      <nav className="relative border-b border-gray-800/50 backdrop-blur-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16">
            <div className="flex items-center">
              <h1 className="text-xl font-medium"> Courted.ai </h1>
            </div>
            <div className="flex items-center space-x-6">
              <Link to="/member/login">
                <Button variant="dark" className="px-6">
                  Log In
                </Button>
              </Link>
              <Link to="/guest">
                <Button variant="dark" className="px-6">
                  Public Use →
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </nav>

      <main className="relative max-w-7xl mx-auto py-24 px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto">
          <h2 className="text-6xl font-medium mb-6 tracking-tight bg-clip-text text-transparent bg-gradient-to-r from-white to-gray-400">
            Redefining the Club Member Experience
          </h2>
          <p className="text-xl text-gray-400 mb-12">
            Your club. Powered with modern technology.
          </p>
          <div className="flex justify-center space-x-4">
            <Link to="/member/register">
              <Button variant="dark" size="lg" className="px-8">
                Get Started →
              </Button>
            </Link>
          </div>
        </div>

        <div className="mt-32 grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          <div className="bg-gray-900/50 backdrop-blur-sm p-8 rounded-2xl border border-gray-800/50 hover:border-gray-700/50 transition-colors">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-blue-500/10 rounded-xl flex items-center justify-center mr-4">
                <svg className="w-6 h-6 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-medium">Court Booking</h3>
            </div>
            <p className="text-gray-400">
              AI-powered court recommendations and a smart booking reservation engine designed for your seamless experience. 
            </p>
          </div>

          <div className="bg-gray-900/50 backdrop-blur-sm p-8 rounded-2xl border border-gray-800/50 hover:border-gray-700/50 transition-colors">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-purple-500/10 rounded-xl flex items-center justify-center mr-4">
                <svg className="w-6 h-6 text-purple-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-medium">Membership Portal</h3>
            </div>
            <p className="text-gray-400">
              Comprehensive membership management with automated billing and digital access control.
            </p>
          </div>

          <div className="bg-gray-900/50 backdrop-blur-sm p-8 rounded-2xl border border-gray-800/50 hover:border-gray-700/50 transition-colors">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-emerald-500/10 rounded-xl flex items-center justify-center mr-4">
                <svg className="w-6 h-6 text-emerald-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-medium">Integrated Payments</h3>
            </div>
            <p className="text-gray-400">
              Seamless payments and contract signing in one place. No more hassle with multiple systems or paperwork.
            </p>
          </div>

          <div className="bg-gray-900/50 backdrop-blur-sm p-8 rounded-2xl border border-gray-800/50 hover:border-gray-700/50 transition-colors">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-amber-500/10 rounded-xl flex items-center justify-center mr-4">
                <svg className="w-6 h-6 text-amber-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
                </svg>
              </div>
              <h3 className="text-xl font-medium">Smart Dashboard</h3>
            </div>
            <p className="text-gray-400">
              All your events, lessons, and reservations in one sleek overview. Stay organized and never miss a beat.
            </p>
          </div>
        </div>
      </main>
    </div>
  );
};

export default MemberLanding;
